import $ from 'jquery'

/**
 *
 * @param url
 * @param module
 * @param action
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 */
export const logEngagement = (url, module, action, params) => {
    if (params) {
        url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param(params);
    }
    $.ajax({
        type: 'POST',
        data: $.param({
            url: url,
            module: module,
            action: action
        }),
        url: '/r/ajax/LogEngagement.jsp'
    });
}

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
export const logEngagementWithDetails = (url, module, action, details) => {
    $.ajax({
        type: 'POST',
        data: $.param({
            url: url,
            module: module,
            action: action,
            details: details
        }),
        url: '/r/ajax/LogEngagement.jsp'
    });
}


// WEBPACK FOOTER //
// ./src/scripts/modules/global/log-engagement.js